"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
function JSONResponseHandler(response) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var responseText, data;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, response.text()];
                case 1:
                    responseText = _a.sent();
                    try {
                        data = JSON.parse(responseText);
                        return [2, data];
                    }
                    catch (err) {
                        if (((response.status / 100) | 0) === 2) {
                            return [2, Promise.resolve({
                                    message: responseText
                                })];
                        }
                        else {
                            return [2, Promise.resolve({
                                    code: response.status,
                                    message: responseText,
                                    httpStatus: response.status,
                                    error: true
                                })];
                        }
                    }
                    return [2];
            }
        });
    });
}
exports.default = JSONResponseHandler;
//# sourceMappingURL=JSONResponseHandler.js.map